module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/10 Husicka rozbourana ocistena.jpg";